export default __webpack_public_path__ + "static/media/Mark-4-Suit-Cycles-09.0bc414a7.jpg";